var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      ref: "modal",
      attrs: {
        name: "team-switcher",
        width: "xs",
        title: _vm.$t("change_team"),
        "body-classes": ["no-padding"]
      },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "", link: "" } },
            _vm._l(_vm.teams, function(team) {
              return _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" }
                  ],
                  key: team.id,
                  staticClass: "team-entry q-px-lg",
                  nativeOn: {
                    click: function($event) {
                      _vm.handleChangeTeam(team.id)
                    }
                  }
                },
                [
                  _c(
                    "q-item-side",
                    { attrs: { left: "" } },
                    [
                      _c("team-logo", {
                        staticClass: "q-headline",
                        attrs: { team: team, height: "64px", width: "64px" }
                      })
                    ],
                    1
                  ),
                  _c("q-item-main", { staticClass: "q-pl-md" }, [
                    _c(
                      "div",
                      { staticClass: "row items-center justify-between" },
                      [
                        _c(
                          "span",
                          { staticClass: "q-title text-grey-8 ellipsis col" },
                          [_vm._v(_vm._s(team.name))]
                        ),
                        _vm.isActiveTeam(team)
                          ? _c(
                              "q-chip",
                              {
                                staticClass:
                                  "positive-tag on-right q-px-sm col-auto",
                                attrs: {
                                  color: "white",
                                  "text-color": "positive",
                                  dense: "",
                                  rounded: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("active")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("span", { staticClass: "q-body-2" }, [
                      _vm._v(_vm._s(_vm.$t("role_" + team.role_id)))
                    ])
                  ])
                ],
                1
              )
            })
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "full-width row justify-between" },
          [
            _c(
              "q-btn",
              {
                attrs: { flat: "", dense: "", color: "primary", icon: "add" },
                on: { click: _vm.handleCreateTeam }
              },
              [_vm._v("\n         " + _vm._s(_vm.$t("new_team")) + "\n      ")]
            ),
            _c(
              "q-btn",
              { attrs: { color: "primary" }, on: { click: _vm.handleClose } },
              [_vm._v(" " + _vm._s(_vm.$t("close")))]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }